import { useEffect, useMemo, useState } from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";
import { useWatch } from "react-hook-form";
import { AutocompleteFieldOption, AutocompleteFieldProps, Constraint } from "./stepper-interfaces";

// function getArrayIntersection(_array: any, _secondArray:any) {
//   return _secondArray.filter(Set.prototype.has.bind(new Set(_array)));
// }

// function useReactiveDropdown({ params }: { params: AutocompleteFieldProps }) {
//   const { control, getValues, setValue } = useFormContext();
//   const { multiple, id, constraints } = params;

//   const populate_constraints = useMemo(() => {
//     const _arr: Constrain[] = [];
//     for (const constrain of constraints) {
//       if (constrain.type !== "populate") continue;
//       _arr.push(constrain);
//     }

//     return _arr;
//   }, [constraints]);

//   let dropdownOptions: any[] = [];

//   const parentValues = useWatch({ control, name: reactiveKey });

//   /** when parent field options change then reactive-dropdown options will change
//    * its value will change if value was selected but now options are not present in parent
//    */
//   useEffect(() => {
//     let _value = getValues(id);

//     if (!_value) return;

//     if (!multiple) {
//       // value is not present in dropdown options then remove value
//       if (!dropdownOptions.includes(_value)) _value = "";
//     }
//     //set value as the common elements between dropdown options and value array
//     else _value = getArrayIntersection(_value, dropdownOptions);
//     setValue(id, _value);
//     //console.log("useReactiveDropdown --> watch -->", key, _value);
//   }, [parentValues]);

//   if (parentValues?.length > 0) {
//     //console.log("useReactiveDropdown --> reactiveValue -->", reactiveValue);
//     //console.log("useReactiveDropdown --> parentValues --> ", parentValues);
//     Object.entries(reactiveValue).forEach(([option, value]) => {
//       if (parentValues.includes(option) && value !== undefined) {
//         dropdownOptions = [...dropdownOptions, ...value];
//         showDropdown = !(hideIfNoData && dropdownOptions.length === 0);
//       }
//     });
//   }

// return {dropdownOptions}
// }

export const StepperDropdown: React.FC<AutocompleteFieldProps> = ({
  options,
  onChange,
  label,
  register,
  unregister,
  setValue,
  constraints,
  id,
  required,
  watch,
  sx,
  multiple = false,
  disabled = false,
  error = false,
  helperText = "",
}) => {
  const value = watch(id);
  const form_values = useWatch();
  const [extendedOptions, setExtendedOptions] = useState<any>([]);
  // const [reactiveKey, setReactiveKey] = useState([]);
  // const parent_values = watch(reactiveKey);
  // console.log('parent_values',parent_values);
  const populate_constraints = useMemo(() => {
    return constraints.filter(({ type }) => type === "populate");
  }, [constraints]);

  const reactive_key = useMemo(() => populate_constraints?.[0]?.field, [populate_constraints]);
  const parent_value = useWatch({ name: reactive_key });
  // const parent_value = watch(reactive_key);
  useEffect(() => {
    if (Object.prototype.toString.call(parent_value) !== "[object Object]" || constraints.length === 0) {
      const options = getExtendedOptions();
      setExtendedOptions(options);
    }
  }, [populate_constraints, parent_value]);

  function getExtendedOptions() {
    if (populate_constraints.length) {
      for (const constrain of populate_constraints) {
        const { kvpair = [], field } = constrain;
        const parent_values = form_values[field];
        if (parent_values === null || parent_values === undefined) continue;
        if (Array.isArray(parent_values)) {
          const parent_values_set = new Set(parent_values);
          let final: any[] = [];
          for (const pair of kvpair) {
            if (parent_values_set.has(pair.value)) final = [...final, ...pair.relatedValues];
          }
          if (final.length) return final;
        } else {
          for (const pair of kvpair) {
            if (parent_values === pair.value) {
              if (pair.relatedValues.includes(value)) {
                setValue(id, multiple ? [] : value);
              } else {
                setValue(id, multiple ? [] : null);
              }
              return pair.relatedValues;
            }
          }
        }
      }
    }
    if (multiple === true) return getOptionsWithSelectAll(options);
    return options;
  }
  useEffect(() => {
    if (register) {
      register(id, { required });
    }

    // return () => {
    //   unregister?.(id);
    // };
  }, []);

  // const extended_options = multiple === true ? getOptionsWithSelectAll() : options;

  function getOptionsWithSelectAll(options: AutocompleteFieldOption[]) {
    // console.log("options_are", options);
    if (options.length === 0 || options.length === 1) return options;
    if (multiple && !value) {
      // console.error("NO_VALUE_FOR_DROPDOWN_WITH_ID", id);
      return ["Select All", ...options];
    }
    if (value.length === options.length) {
      return ["Deselect All", ...options];
    }
    return ["Select All", ...options];
  }

  return (
    <Autocomplete
      size="small"
      multiple={multiple}
      disableCloseOnSelect={multiple}
      limitTags={2}
      options={extendedOptions}
      value={value ?? (multiple === true ? [] : null)}
      onChange={(event, value) => {
        switch (true) {
          case !Array.isArray(value):
            return onChange(value);
          case value.includes("Select All"):
            return onChange(options);
          case value.includes("Deselect All"):
            return onChange([]);
          default:
            return onChange(value);
        }
      }}
      sx={sx}
      disabled={disabled}
      isOptionEqualToValue={(option, value) =>
        typeof option === "object" && typeof value === "object"
          ? option.id === value.id
          : typeof value === "object" && typeof value !== "object"
          ? option.id === value
          : option === value
      }
      renderTags={(value, getTagProps) => {
        return (
          <div>
            <Chip
              size="small"
              variant="outlined"
              label={typeof value[0] === "string" ? value[0] : value[0]?.label}
              {...getTagProps}
            />
            {value.length > 1 && <Chip size="small" label={`+${value.length - 1}`} />}
          </div>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={`${label} ${!!required ? "*" : ""}`}
          placeholder={label}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};
export default StepperDropdown;
